import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { EdgeRectangleTrapezoid } from '@sorare/core/src/atoms/ui/EdgeRectangleTrapezoid';
import {
  AnyRewardConfig,
  Variant,
} from '@sorare/core/src/components/rewards/AnyRewardConfig';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';
import { monetaryAmountFragment } from '@sorare/core/src/lib/monetaryAmount';

import type {
  QuickPlayConversionCreditQuery,
  QuickPlayConversionCreditQueryVariables,
} from './__generated__/index.graphql.ts';

const QUICK_PLAY_CONVERSION_CREDIT_QUERY = gql`
  query QuickPlayConversionCreditQuery($sport: Sport!) {
    currentUser {
      slug
      onboardingConversionCredit(sport: $sport) {
        id
        maxDiscount {
          ...MonetaryAmountFragment_monetaryAmount
        }
      }
    }
  }
  ${monetaryAmountFragment}
` as TypedDocumentNode<
  QuickPlayConversionCreditQuery,
  QuickPlayConversionCreditQueryVariables
>;

const Root = styled.div`
  align-self: center;

  & > * {
    width: auto;
  }
`;
export const ConversionCredit = () => {
  const { sport } = useSportContext();
  const { data } = useQuery(QUICK_PLAY_CONVERSION_CREDIT_QUERY, {
    variables: { sport },
  });

  if (!data?.currentUser?.onboardingConversionCredit) {
    return null;
  }
  const { currentUser } = data;
  const { onboardingConversionCredit } = currentUser;

  if (!onboardingConversionCredit) {
    return null;
  }

  const mockedRewardConfig = {
    __typename: 'ConversionCreditRewardConfig' as const,
    id: 'onboardingConversionCredit',
    maxDiscount: onboardingConversionCredit.maxDiscount,
    percentageDiscount: 0.5,
  };

  return (
    <Root>
      <EdgeRectangleTrapezoid
        padding="var(--half-unit) var(--triple-unit)"
        border="linear-gradient(to bottom, transparent 0%, #111F1C 70%), linear-gradient(to right, #78FFE8, #EDFF95, #78FFE8, #EDFF95, #78FFE8, #EDFF95, #78FFE8)"
      >
        <AnyRewardConfig
          variant={Variant.TEXT}
          anyRewardConfig={mockedRewardConfig}
          textVariantSize="lg"
          customText={({ rewardText }) => (
            <FormattedMessage
              id="ConversionCredit.off"
              defaultMessage="{amount} off"
              values={{
                amount: rewardText,
              }}
            />
          )}
        />
      </EdgeRectangleTrapezoid>
    </Root>
  );
};
